import { render, staticRenderFns } from "./TelefonesTable.vue?vue&type=template&id=9b3cd892"
import script from "./TelefonesTable.vue?vue&type=script&lang=js"
export * from "./TelefonesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports